var _this = this;
import { __assign, __read } from "tslib";
import { DEFAULT_TIMEZONE, momentOverrides } from '@concur/intl-core';
import moment from 'moment-timezone';
export var getDateTimeFormatter = function (locale, dateFormat, timeFormat) {
    // Get moment code if its different from concur code
    var momentLocale = momentOverrides[locale] || locale;
    var localeData = moment().locale(momentLocale).localeData();
    var localeDateFormats = localeData._longDateFormat;
    var userDateFormats = updateDateFormatters(__assign(__assign({}, localeDateFormats), dateFormat), timeFormat);
    var localeKey = "".concat(JSON.stringify(dateFormat), "-").concat(momentLocale, "-").concat(JSON.stringify(timeFormat));
    if (moment.locales().indexOf(localeKey) === -1)
        moment.defineLocale(localeKey, {
            longDateFormat: userDateFormats,
            parentLocale: momentLocale,
        });
    var timeZone = (timeFormat === null || timeFormat === void 0 ? void 0 : timeFormat.timeZone) && moment.tz.zone(timeFormat.timeZone) ? timeFormat.timeZone : DEFAULT_TIMEZONE;
    // Create a new moment instance to avoid side effects of passing moment instance from import
    var newMomentInstance = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        moment.locale(localeKey);
        moment.tz.setDefault(timeZone);
        moment.locale(localeKey); //set locale before and after tz update
        moment.fn.local = function local() {
            return moment.tz(timeZone); //override browser timezone
        };
        return moment.apply(_this, args);
    };
    // Add static props such as min, max to newMomentInstance
    var newMomentInstanceWithStaticProps = Object.assign(newMomentInstance, moment);
    return newMomentInstanceWithStaticProps;
};
export var getDateFormat = function (source) {
    var _a, _b, _c, _d, _e, _f;
    var longDateFormats = {};
    // eslint-disable-next-line no-unsafe-optional-chaining
    var _g = (_a = source === null || source === void 0 ? void 0 : source.userPrefs) === null || _a === void 0 ? void 0 : _a.localeData, _h = _g.locale, locale = _h === void 0 ? 'en' : _h, timeFormat = _g.timeFormat;
    var _j = timeFormat || {}, hour12 = _j.hour12, _k = _j.timeSeparator, timeSeparator = _k === void 0 ? ':' : _k;
    if (moment && locale) {
        // Get possible long date formats for certain locale
        // eslint-disable-next-line no-underscore-dangle
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore-next-line
        var momentLongDateFormats_1 = ((_f = (_e = (_d = (_c = (_b = moment()) === null || _b === void 0 ? void 0 : _b.locale) === null || _c === void 0 ? void 0 : _c.call(_b, locale)) === null || _d === void 0 ? void 0 : _d.localeData) === null || _e === void 0 ? void 0 : _e.call(_d)) === null || _f === void 0 ? void 0 : _f._longDateFormat) || {};
        // Map over all possible moment long date formats, alter them based on preferences,
        // and add them to the dateFormat object
        Object.keys(momentLongDateFormats_1).forEach(function (key) {
            var value = momentLongDateFormats_1[key];
            // This line isn't doing anything because the line below this overwrites it
            var newValue = value.replace(/h:m:s/);
            // Replace : with preferred time separator. ex: HH:mm -> HH.mm
            newValue = value.replace(/(H|h|m):(m|s)/g, "$1".concat(timeSeparator, "$2"));
            if (!hour12) {
                // Replace m A or s A with m or s and replace all h with H
                // ex: h:mm A -> H:mm
                newValue = newValue.replace(/(m|s)\sA/g, '$1').replace(/h/g, 'H');
            }
            else if (newValue.indexOf(' A') === -1) {
                // Replace all H with h and add A after m or s
                // ex: H.mm -> h.mm A
                newValue = newValue.replace(/H/g, 'h').replace(/(m|s)($|\s)/, '$1 A$2');
            }
            // Date prefs already exist, add time preferences if they don't already exist
            if (!(longDateFormats === null || longDateFormats === void 0 ? void 0 : longDateFormats[key])) {
                longDateFormats[key] = newValue;
            }
        });
    }
    return longDateFormats;
};
function updateDateFormatters(dateFormat, timeFormat) {
    var _a = timeFormat !== null && timeFormat !== void 0 ? timeFormat : {}, _b = _a.timeSeparator, timeSeparator = _b === void 0 ? ':' : _b, _c = _a.hour12, hour12 = _c === void 0 ? true : _c;
    var formatEntries = Object.keys(dateFormat).map(function (key) { return [key, dateFormat[key]]; });
    var timePrefEntries = formatEntries.map(setTimePreference(timeSeparator, hour12));
    var dateFormatsObject = {};
    timePrefEntries.forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        dateFormatsObject[key] = value;
    });
    return dateFormatsObject;
}
function setTimePreference(timeSeparator, hour12) {
    return function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var newValue = value.replace(/(H|h|m):(m|s)/g, "$1".concat(timeSeparator, "$2"));
        if (!hour12) {
            newValue = newValue.replace(/(m|s)\sA/g, '$1').replace(/h/g, 'H');
        }
        else if (newValue.indexOf(' A') === -1) {
            newValue = newValue.replace(/H/g, 'h').replace(/(m|s)($|\s)/, '$1 A$2');
        }
        return [key, newValue];
    };
}
